
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Puneairporttomumbaitaxi() {



  const cardData =
  {
    keyword: '  Pune Airport to Mumbai Taxi',
    heading: 'Vaishnavi Travels: Pune Airport to Mumbai Taxi',
    headingDescription: 'Vaishnavi Travels offers reliable and affordable Pune Airport to Mumbai Taxi service, ensuring smooth and timely transfers for business travelers, families, and tourists. Our taxis are well-maintained with comfortable seating, strong air-conditioning, and ample luggage space, making long-distance airport travel convenient and stress-free. With professional chauffeurs, punctual pickups, and flexible booking options, we provide hassle-free connectivity between Pune Airport and Mumbai. Whether it’s an early morning flight, late-night arrival, or urgent business trip, Vaishnavi Travels guarantees safe, reliable, and comfortable taxi services from Pune Airport to Mumbai.',

    top: 'Top Places to Visit in Mumbai with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s most iconic monument overlooking the Arabian Sea. Constructed in Indo-Saracenic style, it commemorates the visit of King George V and Queen Mary. Today, it is a bustling hub for tourists, ferry rides, and photography. The monument glows beautifully at night, with the Taj Mahal Palace Hotel creating a stunning backdrop. Street vendors and performers add charm to the experience. Gateway of India is Mumbai’s proud symbol of history and grandeur."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also called the Queen’s Necklace, is a 3.6 km promenade curving along the Arabian Sea. At night, the streetlights resemble a necklace, creating a mesmerizing view. Locals and tourists enjoy evening walks, jogging, and watching the sunset here. During monsoon, the waves crashing against the promenade create dramatic sights. Its proximity to Girgaon Chowpatty adds to its popularity. Marine Drive is Mumbai’s iconic seaside escape."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves, a UNESCO World Heritage Site, are located on Elephanta Island, 11 km from Mumbai. Dating back to the 5th–8th centuries, the caves are dedicated to Lord Shiva, with the Trimurti sculpture as the highlight. Visitors reach the caves by ferry from the Gateway of India. The rock-cut halls and intricate carvings showcase India’s artistic brilliance. Surrounded by greenery, it is both a cultural and natural retreat. Elephanta Caves are Mumbai’s timeless treasure of heritage."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "CSMT, formerly known as Victoria Terminus, is a UNESCO World Heritage Site and one of Mumbai’s busiest railway stations. Built in 1887, it blends Gothic Revival and Indian architectural styles. Its domes, stained glass windows, and carvings make it an architectural marvel. At night, the illuminated façade creates a breathtaking sight. It remains a hub of local and long-distance trains. CSMT is Mumbai’s living monument of colonial architecture and connectivity."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most famous seaside attractions, stretching for several kilometers. It is popular for its golden sands, street food stalls, and vibrant crowds. Visitors enjoy local delicacies like pav bhaji, bhel puri, and ice gola. Bollywood celebrities often visit, as many live nearby. Sunsets at Juhu create a magical atmosphere for couples and families. Juhu Beach is Mumbai’s lively hub of leisure and culture."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "The Siddhivinayak Temple in Prabhadevi is Mumbai’s most revered shrine dedicated to Lord Ganesha. Built in 1801, it attracts lakhs of devotees including Bollywood stars and politicians. The idol’s right-turned trunk is considered highly auspicious. Tuesdays see massive crowds for special darshan rituals. The temple is also known for its charitable activities. Siddhivinayak Temple is Mumbai’s spiritual and cultural heart."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, built in 1431, stands on a small islet connected by a narrow causeway in the Arabian Sea. It houses the tomb of Pir Haji Ali Shah Bukhari, a revered saint. The white marble mosque attracts people of all faiths. Pilgrims and tourists walk along the causeway during low tide, making the journey memorable. Sunsets here are breathtaking with the sea surrounding the shrine. Haji Ali Dargah is Mumbai’s symbol of faith and unity."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is Mumbai’s vibrant shopping street, packed with stalls selling clothes, jewelry, antiques, and handicrafts. Tourists love its bustling atmosphere and bargain shopping. Iconic cafés like Leopold Café and Café Mondegar add historic charm. Heritage buildings along the stretch enrich the cultural vibe. It is one of the best places to experience Mumbai’s cosmopolitan spirit. Colaba Causeway is the city’s ultimate street shopping hub."
  },
  {
    "title": "Girgaon Chowpatty",
    "description": "Girgaon Chowpatty, also known as Chowpatty Beach, is a cultural hotspot in Mumbai. It is famous for Ganesh Visarjan, where thousands gather for immersion processions. Families enjoy evenings here with street food like pav bhaji and kulfi. The beach becomes lively during festivals and fairs. Its Arabian Sea backdrop adds natural beauty to the setting. Girgaon Chowpatty is Mumbai’s seaside celebration of culture and devotion."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park, spread over 100 sq km, is one of the world’s largest parks within a metropolitan city. It is home to leopards, deer, monkeys, and over 250 bird species. The park also houses the ancient Kanheri Caves, a group of Buddhist rock-cut structures. Visitors enjoy safaris, boating, and trekking trails. It offers greenery and fresh air amidst Mumbai’s urban chaos. Sanjay Gandhi National Park is the city’s natural oasis of wildlife and heritage."
  }
],


    "services": [
    {
      "name": "Pune Airport Pickup Cab",
      "description": "Reliable and timely airport pickup cab services in Pune, ensuring smooth and hassle-free arrivals. Our professional drivers monitor flight timings closely to provide prompt pickups, assist with luggage, and offer comfortable rides to your destination in Pune or nearby areas, making your travel experience stress-free and pleasant."
    },
    {
      "name": "Pune to Mumbai Airport Transfer",
      "description": "Convenient and comfortable taxi transfers from Pune to Mumbai’s Chhatrapati Shivaji Maharaj International Airport (CSMIA). Our service ensures timely departures with well-maintained vehicles, experienced drivers familiar with airport routes, and flexible booking options for both one-way and round trips to meet your travel schedule."
    },
    {
      "name": "AC Taxi to CSMIA",
      "description": "Travel in cool comfort with our air-conditioned taxi service from Pune to Mumbai’s CSMIA airport. Ideal for business and leisure travelers, these AC taxis feature plush interiors and efficient cooling, making your airport transfer smooth, refreshing, and relaxing regardless of Mumbai’s traffic and weather."
    },
    {
      "name": "One Way Airport Cab",
      "description": "Affordable one-way airport cab rentals from Pune to Mumbai airport or vice versa. Perfect for travelers with specific itineraries or onward plans, our one-way service provides transparent pricing, courteous drivers, and reliable transportation to ensure your airport journey is seamless."
    },
    {
      "name": "Round Trip Airport Transfer",
      "description": "Flexible round trip airport transfer services between Pune and Mumbai, allowing you to book both your arrival and departure rides together. Enjoy convenient scheduling, vehicle options, and professional drivers who prioritize punctuality and comfort throughout your airport journeys."
    },
    {
      "name": "Budget Airport Taxi Pune",
      "description": "Cost-effective budget airport taxi services in Pune for travelers looking to save on transfers without compromising safety or comfort. Our fleet includes well-maintained vehicles providing basic amenities and reliable service at competitive rates, ideal for solo travelers and small groups."
    },
    {
      "name": "SUV Airport Cab Service",
      "description": "Premium SUV airport cab rentals offering spacious interiors, luggage capacity, and superior road handling for your transfer between Pune and Mumbai airport. Perfect for families, corporate travelers, and those seeking enhanced comfort and style during their airport commute."
    },
    {
      "name": "Corporate Airport Pickup",
      "description": "Professional corporate airport pickup services designed for business travelers requiring punctual, discreet, and comfortable transfers. Our fleet includes executive vehicles with experienced chauffeurs who understand the importance of timely arrivals and seamless transportation to and from Pune and Mumbai airports."
    },
    {
      "name": "Family Airport Transfer",
      "description": "Tailored airport transfer services for families traveling between Pune and Mumbai airports, ensuring safe and convenient rides with spacious vehicles and courteous drivers. We accommodate luggage needs and provide a comfortable environment suitable for travelers of all ages."
    },
    {
      "name": "Online Airport Taxi Booking",
      "description": "Convenient and secure online booking platform for airport cabs between Pune and Mumbai. Choose your vehicle type, schedule your transfer, and receive instant confirmation with 24/7 customer support, ensuring a smooth and hassle-free airport travel experience."
    },
    {
      "name": "24×7 Airport Cab Service",
      "description": "Round-the-clock airport taxi services available for transfers between Pune and Mumbai, accommodating early morning flights, late-night arrivals, and urgent travel needs. Our professional drivers and well-maintained vehicles ensure reliable and timely service anytime you require."
    },
    {
      "name": "Sedan/SUV Airport Cab",
      "description": "Choose from a range of sedan and SUV vehicles for your airport transfers between Pune and Mumbai. Whether you prefer a sleek sedan for business travel or a spacious SUV for group and family journeys, our fleet offers options to suit every requirement with comfort and style."
    },
    {
      "name": "Airport Shuttle Pune to Mumbai",
      "description": "Shared and private airport shuttle services from Pune to Mumbai airport, providing cost-effective and efficient transfers. Ideal for solo travelers and small groups, our shuttle options offer flexible scheduling, safe rides, and experienced drivers familiar with the busy airport routes."
    }
  ],
  "tableData": [
    ["Pune Airport Pickup Cab", "Pune to Mumbai Airport Transfer"],
    ["AC Taxi to CSMIA", "One Way Airport Cab"],
    ["Round Trip Airport Transfer", "Budget Airport Taxi Pune"],
    ["SUV Airport Cab Service", "Corporate Airport Pickup"],
    ["Family Airport Transfer", "Online Airport Taxi Booking"],
    ["24×7 Airport Cab Service", "Sedan/SUV Airport Cab"],
    ["Airport Shuttle Pune to Mumbai"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Pune Airport to Mumbai Taxi",
    "WhyChoosedescription": "Vaishnavi Travels provides comfortable and reliable taxi services from Pune Airport to Mumbai, ideal for business trips, airport transfers, and personal travel."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from Swift Dzire, Ertiga, Innova, Urbania, and Tempo Traveller based on your group size and comfort needs."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Our taxis are regularly serviced and sanitized to ensure your safety and comfort during the journey."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with the Route",
    "WhyChoosedescription": "Our professional drivers know the best routes between Pune Airport and Mumbai for a smooth and timely travel experience."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "We offer all-inclusive pricing covering fuel, tolls, parking, and driver allowance with no hidden charges."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop-off Locations",
    "WhyChoosedescription": "Enjoy convenient pickup from Pune Airport and drop-off at your preferred location anywhere in Mumbai."
  },
  {
    "WhyChooseheading": "Ideal for Airport Transfers and Business Travel",
    "WhyChoosedescription": "Perfect for individuals and corporate travelers looking for hassle-free airport taxi service."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
    "WhyChoosedescription": "Our customer support team is available round-the-clock to assist with bookings, itinerary planning, and travel inquiries."
  }
]























  }




const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels provide taxi services from Pune Airport to Mumbai?',
      answer: 'Yes, Vaishnavi Travels offers reliable and comfortable taxi services from Pune Airport to Mumbai, perfect for business travelers, tourists, and airport transfers.',
    },
    {
      question: 'What types of vehicles are available for the Pune Airport to Mumbai route?',
      answer: 'We provide a variety of vehicles including Swift Dzire, Ertiga, Innova, and Tempo Travellers to suit solo travelers, small groups, and large parties.',
    },
    {
      question: 'What is the typical fare for a taxi from Pune Airport to Mumbai?',
      answer: 'Fares generally start from ₹2,500 for a hatchback or sedan. Rates vary depending on vehicle type, trip duration, and any additional requirements.',
    },
    {
      question: 'How long does the journey from Pune Airport to Mumbai usually take?',
      answer: 'The trip typically takes between 3.5 to 4.5 hours depending on traffic and the chosen route, mostly via the Pune-Mumbai Expressway.',
    },
    {
      question: 'Can I book a one-way or round-trip taxi from Pune Airport to Mumbai?',
      answer: 'Yes, Vaishnavi Travels offers both one-way and round-trip taxi bookings with flexible packages and transparent pricing.',
    },
    {
      question: 'How far in advance should I book a taxi from Pune Airport to Mumbai?',
      answer: 'It is recommended to book at least 24 hours in advance, especially during peak travel seasons, to ensure vehicle availability.',
    },
    {
      question: 'Is doorstep pickup available for Pune Airport taxi bookings?',
      answer: 'Yes, we provide convenient doorstep pickup and drop-off services from Pune Airport and locations across Mumbai.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Saurabh Kulkarni",
    position: "Business Traveler",
    feedback:
      "Vaishnavi Travels made my Pune to Mumbai airport transfer smooth and stress-free. The driver was punctual and the cab was clean and comfortable. Highly recommended!",
    rating: 5,
  },
  {
    name: "Ms. Priya Deshpande",
    position: "Tourist",
    feedback:
      "I booked a cab online with Vaishnavi Travels for my Pune Airport to Mumbai trip. The booking was easy, the fare was reasonable, and the service was excellent.",
    rating: 5,
    style: "style-2",
  }
];














































































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];


const puneAirportToMumbaiTaxiSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune Airport to Mumbai Taxi",
  "description": "Reliable Pune Airport pickup and drop service to Mumbai Airport (CSMIA). AC and budget taxis available for one-way and round trips. SUV and family taxi options.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Vaishnavi Travels",
    "telephone": "+91-9765685295",
    "url": "https://vaishnavitravel.com/pune-airport-to-mumbai-taxi"
  },
  "areaServed": [
    {
      "@type": "City",
      "name": "Pune"
    },
    {
      "@type": "Airport",
      "name": "Chhatrapati Shivaji Maharaj International Airport"
    }
  ],
  "serviceType": [
    "Pune Airport Pickup Cab",
    "Pune to Mumbai Airport Transfer",
    "AC Taxi to CSMIA",
    "One Way Airport Cab",
    "Round Trip Airport Transfer",
    "Budget Airport Taxi Pune",
    "SUV Airport Cab Service",
    "Corporate Airport Pickup",
    "Family Airport Transfer",
    "Online Airport Taxi Booking",
    "24x7 Airport Cab Service",
    "Sedan/SUV Airport Cab",
    "Airport Shuttle Pune to Mumbai"
  ],
  "availability": "https://schema.org/InStock"
};




  return (
    <div>
<Helmet>
  <title>Pune Airport to Mumbai Taxi | Reliable Airport Transfer Service</title>
  <meta
    name="description"
    content="Reliable Pune Airport pickup and drop service to Mumbai Airport (CSMIA). AC and budget taxis available for one-way and round trips. SUV and family taxi options."
  />
  <meta
    name="keywords"
    content="Pune Airport Pickup Cab, Pune to Mumbai Airport Transfer, AC Taxi to CSMIA, One Way Airport Cab, Round Trip Airport Transfer, Budget Airport Taxi Pune, SUV Airport Cab Service, Corporate Airport Pickup, Family Airport Transfer, Online Airport Taxi Booking, 24x7 Airport Cab Service, Sedan/SUV Airport Cab, Airport Shuttle Pune to Mumbai"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneAirportToMumbaiTaxiSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/69.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Puneairporttomumbaitaxi;